"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cavareno": {
    "5c544eac": [{
      "hkey": "1cfc9193",
      "slug": "cavareno",
      "name": "Cavareno",
      "primary": true,
      "skipSearch": false
    }],
    "ausiel": [{
      "hkey": "1cfc9193",
      "slug": "cavareno",
      "name": "Cavareno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6a34e167": [{
      "hkey": "1cfc9193",
      "slug": "cavareno",
      "name": "Cavareno",
      "primary": true,
      "skipSearch": false
    }],
    "bus": [{
      "hkey": "1cfc9193",
      "slug": "cavareno",
      "name": "Cavareno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9afe6d19": [{
      "hkey": "1cfc9193",
      "slug": "cavareno",
      "name": "Cavareno",
      "primary": true,
      "skipSearch": false
    }],
    "larseti": [{
      "hkey": "1cfc9193",
      "slug": "cavareno",
      "name": "Cavareno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b807aba3": [{
      "hkey": "1cfc9193",
      "slug": "cavareno",
      "name": "Cavareno",
      "primary": true,
      "skipSearch": false
    }],
    "ruch": [{
      "hkey": "1cfc9193",
      "slug": "cavareno",
      "name": "Cavareno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c0f2387f": [{
      "hkey": "1cfc9193",
      "slug": "cavareno",
      "name": "Cavareno",
      "primary": true,
      "skipSearch": false
    }],
    "sovic": [{
      "hkey": "1cfc9193",
      "slug": "cavareno",
      "name": "Cavareno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "18dbe029": [{
      "hkey": "1cfc9193",
      "slug": "cavareno",
      "name": "Cavareno",
      "primary": true,
      "skipSearch": false
    }],
    "splazuela": [{
      "hkey": "1cfc9193",
      "slug": "cavareno",
      "name": "Cavareno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;